export enum StatusPodania {
  Robocze = 1,
  Wyslano = 2,
  DoSkompletowania = 3,
  Dostarczono = 4,
  CofnietoDoEdycji = 5,
  Zarejestrowano = 6,
  CofnietoDoUzupelnienia = 7,
  WyslanoUzupelnione = 8,
  PozostawionoBezRozpoznania = 9,
  Wycofano = 10,
  Odrzucono = 11,
}
